import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="cc cc-bg min-h-screen flex items-center justify-center text-white px-5" data-testid="payment-cancel-page">
      <div className="cc-card rounded-2xl p-10 max-w-md w-full text-center">
        <XCircle size={44} className="mx-auto text-slate-400" />
        <h1 className="cc-heading text-2xl font-700 mt-5">Checkout canceled</h1>
        <p className="text-slate-400 text-sm mt-2">
          No charge was made. You can upgrade anytime from your billing page.
        </p>
        <Link to="/credit/app/billing"
          className="inline-block cc-btn-primary text-white rounded-xl px-6 py-2.5 text-sm font-500 mt-6 w-full"
          data-testid="payment-cancel-continue">
          Back to Billing
        </Link>
      </div>
    </div>
  );
}
